// src/Hikayeler.js — GÜNCEL
// KURAL 6: Mobil ve Masaüstü ayrı dosyalardan çalıştırılır.
// Değişiklik: StoryModal importu kaldırıldı; yerine StoryModalMobile/Desktop seçimi eklendi.
// Güncelleme: following subcollection'dan takip listesi çekiliyor + glow useRef ile kalıcı

import { useEffect, useState, useMemo, useRef, useCallback, lazy, Suspense } from "react";
import { db, storage, auth } from "./firebase";
import {
  collection,
  addDoc,
  query,
  where,
  onSnapshot,
  serverTimestamp,
  getDocs,
  limit,
  Timestamp
} from "firebase/firestore";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
// P2-6 — Story ring mute filtresi ("all" + "stories" tipleri ring'den gizlenir).
import { useHiddenUids } from "./hooks/useHiddenUids";
import { getFollowingUids } from "./services/follows";
import { IkonKoprusu } from "./icon-system/runtime/IkonKoprusu";

// `Overlay` bir TİP: `import type` derlemede tamamen SİLİNİR, yani aşağıdaki
// `lazy(() => import("./components/StoryComposer"))` chunk'ını geri çekmez
// (değer importu olsaydı tembelleştirme anlamsız olurdu).
import type { Overlay } from "./components/StoryComposer";
// ══════════════════════════════════════════════════════════════════════════
// 🔴 TEMBELLEŞTİRMENİN ÖLÇÜLEN YAN ETKİSİ — STİL SAYFASI EAGER GERİ ÇAĞRILDI
// ══════════════════════════════════════════════════════════════════════════
// Aşağıdaki `lazy()` (bkz. `const StoryModalDesktop = …`) yalnız JS'i
// ertelemez: modülün İÇİNDEN import ettiği stil sayfası da
// (`StoryModalDesktop.tsx:32 → "./StoryModalDesktop.css"`) ana `main.css`
// paketinden ÇIKAR. Ve o dosyada modale ÖZGÜ olmayan bir kural yaşıyor:
//
//     .icon-btn{ background: rgba(255,255,255,.12); border:0; color:#fff;
//                padding:8px 12px; border-radius:999px; cursor:pointer; }
//
// `.icon-btn` GENEL bir yardımcı sınıftır (ölçüldü: 9 dosyada 28 çağrı yeri),
// aralarında `ProfileHeaderMobile.tsx`in profil menü düğmesi
// (`className="phm-menu-btn … icon-btn"`). `.phm-menu-btn` kendi
// `background`/`border` sıfırlamasını YAZMIYOR — `border:0`ı SADECE bu dosya
// veriyordu. Stil ana paketten düşünce düğme tarayıcının VARSAYILAN
// `<button>` görünümüne döndü.
//
// 📏 GÖZ TURUNDA ÖLÇÜLDÜ (2026-09-01, `goz/gece2-entegrasyon`@538277819):
//   karedeki kutu → dolgu rgb(239,239,239) (UA `ButtonFace`) · kenarlık
//   rgb(84,84,84); referansta aynı bölge saf beyazdı rgb(255,255,255).
//   İmza ~30 karede: `04-profile` %0,560 · `04b-profile-other`ın 6 190 px'i ·
//   `05-profile-mycards`ın 7 375 px'i · 27-sidebar-heights · 65/68/69 aynısı.
// 🧭 VE ASIL DERS: kusur ölçüldü ama HİÇBİR kare onun yüzünden kırmızıya
//   DÖNMEDİ — sahnelerin çoğunda fark %1 eşiğinin ALTINDA kaldı. Eşiği olan
//   bir ölçüt, eşik-altı bir gerilemeyi tanım gereği göremez.
//
// ONARIM: JS tembel KALIR (turun ölçtüğü kazanç 1,5 MB'lık JS'ti, CSS değil),
// stil sayfası EAGER geri bağlanır. Satırın KONUMU rastgele değil: bu, eski
// `import StoryModalDesktop from "./StoryModalDesktop"`un `origin/main`teki
// yeriydi (31. satır, `"./Hikayeler.css"`ten ÖNCE) → `main.css` içindeki
// kural sırası da korunur.
// ⚠️ Asıl borç KAPATILMADI, GÖRÜNÜR kılındı: genel bir yardımcı sınıfın
// modale özgü stil sayfasında yaşaması yanlıştır. Taşımak cascade sırasını
// değiştirir (`.icon-btn`in `color:#fff`i bugün `.phm-menu-btn`e KAYBEDİYOR
// — bu yalnız GÖZ referans piksellerinden çıkarıldı, gerçek derlemeden
// ÖLÇÜLMEDİ) ve o ölçüm bu turda YAPILMADI.
// Bekçisi: `src/tembelCssSizintiKapisi.test.ts` (11 gerçek mutasyon kırmızı).
import "./StoryModalDesktop.css";
import { notifyMentionsInStoryOverlays } from "./services/storyMentions";
// ÖLÇEK FAZ 1 — izlendi-senkronu artık users/{me}/izlenenHikayeler'den
// (izleyenler[] hot-doc yazımı durduruldu; bkz. services/storyViews.js).
import { watchSeenStories } from "./services/storyViews";
// DENETİM FIX — 5★ stub'ı: content/{story_*} doc'unu YAZAR oluşturur
// (rules create authorId==auth.uid ister; izleyici oluşturamadığından
// hikaye puanlama sessizce permission-denied alıyordu).
import { ensureContentDoc } from "./reputationClient";
// PR-33 — video guardrail + best-effort poster (upload öncesi).
import { validateVideoFile, captureVideoPoster } from "./utils/videoGuard";
// PR-38 — gerçek sunucu/rules create cooldown ön-talebi.
import { claimCreateSlot } from "./services/createCooldown";

import "./Hikayeler.css";
import { DEFAULT_AVATAR_NEUTRAL } from "./utils/avatar";

// ── #1019 YAVAŞ AĞ — ÜÇÜ DE `lazy` (davranış deltası SIFIR) ──────────────
// Bu üç bileşenin üçü de KOŞULLU render ediliyor (`composerFile && …`,
// `modalAcik && aktifGrup && …`) — yani ilk boyamada DOM'a hiç girmiyorlar,
// ama ilk PAKETTE duruyorlardı. Ölçüm (main.*.js.map):
//   StoryModalMobile 19 463 B · StoryComposer 19 161 B · StoryModalDesktop
//   17 436 B (+ StoryOverlays/StoryInteractiveStickers zincirleri)
// `Hikayeler` App.tsx'ten EAGER import edilir (feed'in üst şeridi), bu yüzden
// tüm zincir ana pakete düşüyordu. Desen bu depoda zaten var ve AYNI iki
// bileşen orada da `lazy`: `app/appModals.tsx:41-42`. Yani burada ikinci bir
// desen icat edilmiyor, var olan desenle HİZALANIYOR (iki çağrı yerinden biri
// eager, diğeri lazy olması zaten ayrışmaydı).
const StoryModalMobile = lazy(() => import("./StoryModalMobile"));
const StoryModalDesktop = lazy(() => import("./StoryModalDesktop"));
// Hikaye composer'ı — sticker/overlay düzenleme adımı (IG parite + niş)
const StoryComposer = lazy(() => import("./components/StoryComposer"));

// ── #1019 YAVAŞ AĞ — `browser-image-compression` ARTIK ÇAĞRI YERİNDE YÜKLENİR.
// ÖLÇÜLDÜ (build/static/js/main.*.js.map, kaynak başına üretilen bayt):
// bu paket ANA PAKETTE 53 068 B tutuyordu (%3,5) ve YALNIZ kullanıcı bir
// hikâye görseli SEÇTİĞİNDE kullanılıyor. `yavas3g`de (51 200 B/sn) o 53 kB,
// UYGULAMA HİÇ AÇILMADAN önce ödenen ~1,0 sn'dir. Desen uydurulmadı — bu
// depodaki emsali `myclipsv3/profile/EditProfileSheet.tsx:386` (aynı paket,
// aynı `mod.default` normalizasyonu, aynı "sıkıştırma çökerse ham dosya"
// düşüşü). Davranış deltası SIFIR: hata yolunda da eski kod ham dosyayı
// yüklüyordu (aşağıdaki catch aynen duruyor).
// İMZA ÜRETİCİDEN: paketin kendi tipi `(file: File, options) => Promise<File>`
// döner (`browser-image-compression/dist/browser-image-compression.d.ts`), yani
// dönüş `File` — `Blob`a genişletmek çağrı yerindeki `.name` erişimini kırardı
// ve bu, tip değişikliğinin davranışa sızması olurdu (kanon: "tip-yalnız
// değişiklik, davranış deltası SIFIR").
type GorselSikistirSecenek = { maxSizeMB: number; maxWidthOrHeight: number; useWebWorker: boolean };
async function imageCompression(file: File, opts: GorselSikistirSecenek): Promise<File> {
  const mod: unknown = await import("browser-image-compression");
  const fn = ((mod as { default?: unknown }).default || mod) as (f: File, o: GorselSikistirSecenek) => Promise<File>;
  return fn(file, opts);
}


/**
 * ── HİKÂYE ŞEKİLLERİ — ÜRETİCİDE TANIMLI ────────────────────────────────
 * Bu dosya hikâyeleri Firestore'dan çekip yazara göre gruplayan ÜRETİCİ
 * (aşağıda ~262-281 `grouped` reduce'u). İki tüketici — `StoryModalMobile`
 * ve `StoryModalDesktop` — aynı veriyi okuyor.
 *
 * 🧭 Şekil ikizden ikize DEĞİL, ortak üreticiden devralınıyor. Kardeş
 *    bileşenin tipini import etmek kopya sözleşme üretir ve ikisi zamanla
 *    ayrışır (`GoruntulenenOge`/`OneCikanOgesi` derslerinin ikizi).
 *
 * 📏 ÇAĞRI YERİ SAYIMI (EMİR, yeni desen `<X\b`):
 *   <StoryModalMobile  → 2  (app/appModals.tsx:298 · Hikayeler.tsx:828)
 *   <StoryModalDesktop → 2  (app/appModals.tsx:300 · Hikayeler.tsx:839)
 *   ⚠️ Eski desen `<X[ />]` etiket adından sonra SATIR SONU gelen çok-satırlı
 *      JSX'i kaçırıyordu ve bu ikizde `Hikayeler.tsx`'i hiç göstermemişti.
 *
 * Alanlar ÖLÇÜLDÜ: iki tüketicinin okuduğu adların birleşimi. Hepsi
 * opsiyonel — Firestore dokümanı, `||`/`?.` zincirleriyle okunuyor.
 */
export type HikayeOgesi = {
  id?: string;
  authorId?: string;
  authorUsername?: string;
  authorProfilePic?: string;
  mediaUrl?: string;
  mediaType?: string;
  posterUrl?: string;
  storagePath?: string;
  /** ⚠️ #769'da `unknown`du; ÜRETİCİ okundu ve daraltıldı. Firestore
   *  `Timestamp`ı (`toMillis(): number`) ama local (pending
   *  `serverTimestamp()`) snapshot'ta `null` gelebiliyor — `regroup`'un
   *  kendi yorumu bunu söylüyor ve gövdeler tam olarak `tarih?.toMillis?.()`
   *  yapıyor. `toMillis` opsiyonel: iki tüketici de (`StoryModal*`) varlığını
   *  önce sınıyor. Daha geniş (`unknown`) yazmak tüketicileri `as` ile
   *  bastırmaya zorluyordu; daha dar (`Timestamp`) yazmak `null` dalını yalanlar. */
  tarih?: { toMillis?: () => number } | null;
  audience?: string;
  overlays?: unknown[];
  izleyenler?: unknown[];
  viewersCount?: number;
  style?: unknown;
};

/** Yazara göre gruplanmış hikâye kümesi — `grouped` reduce'unun çıktısı. */
export type HikayeGrubu = {
  authorId?: string;
  authorUsername?: string;
  authorProfilePic?: string;
  stories: HikayeOgesi[];
  hasCloseFriendsStory: boolean;
  latestMs: number;
};
/** Dönüş `unknown[]`, `string[]` DEĞİL: kaynak, kullanıcının yazabildiği
 *  `localStorage["watchedStories"]` anahtarının `JSON.parse`'ı ve hiçbir yerde
 *  doğrulanmıyor — "string dizisi" doğrulanmamış bir iddia olurdu. Gövdenin
 *  tüm tüketicileri (`includes`, `filter`, spread, `JSON.stringify`) eleman
 *  tipinden bağımsız çalışıyor, dolayısıyla daha dar bir tipe gerek yok. */
const readWatched = (): unknown[] => {
  try {
    const raw = localStorage.getItem("watchedStories");
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

// Glow style'ı DOM'a doğrudan yaz — CSS cascade'i bypass eder
const GLOW_ON  = "0 0 8px 2px rgba(112,0,255,0.35), 0 0 4px 1px rgba(255,0,200,0.25)";
// IG paritesi — yakın arkadaş hikayesi: yeşil glow (halka formu kare kalır)
const GLOW_CF  = "0 0 8px 2px rgba(16,185,129,0.45), 0 0 4px 1px rgba(52,211,153,0.3)";
const GLOW_OFF = "none";

// IG paritesi — hikaye videosu segment sınırı (60 sn)
const STORY_VIDEO_MAX_SEC = 60;
// PR-33 — story video MB guardrail'i (storage.rules 200MB backstop; client
// daha sıkı). 50MB üstü upload BAŞLAMADAN reddedilir (egress/siyah-ekran fix).
const STORY_VIDEO_MAX_BYTES = 50 * 1024 * 1024;
// PR-33 — eski local readVideoDurationSec kaldırıldı → utils/videoGuard
// (validateVideoFile içinde readVideoDurationSec, null-on-error ile).

/**
 * 📏 ÇAĞRI YERİ SAYIMI (EMİR, desen `<X\b`): <Hikayeler → 1 çağrı
 *    (App.tsx:1025, `currentUserProfile={currentUserProfile}` — veri).
 *    Fonksiyon argümanı geçen çağrı YOK.
 * Prop alanları ölçüldü: gövde beşini okuyor.
 */
function Hikayeler({ currentUserProfile }: {
  /** `uid` ZORUNLU, diğer dördü opsiyonel — ÜRETİCİ ölçüldü:
   *  `store/authStore.ts:134` profili TEK yerde kurar,
   *  `{ uid: firebaseUser.uid, ...snap.data() }`. Yani nesne varsa `uid`
   *  daima string; profil yoksa değer `null` (a.g.e. 41/144/199).
   *  `setCurrentUserProfile` (a.g.e. 60) dışarıdan HİÇ çağrılmıyor
   *  (repo geneli grep: 0 çağrı) → ikinci bir yazar yok. Diğer dört alan
   *  `snap.data()`ten gelir, dolayısıyla opsiyonel. */
  currentUserProfile?: {
    uid: string;
    kullaniciAdi?: string;
    profilFoto?: string;
    isPrivate?: boolean;
    takipEdilenler?: string[];
  } | null;
}) {
  // Şekil bu dosyanın KENDİ ürettiği (grouped reduce) — yukarıda tanımlı.
  const [storiesByUser, setStoriesByUser] = useState<HikayeGrubu[]>([]);
  const [isUploadingStory, setIsUploadingStory] = useState(false);
  // PR-ComposerV1b — StoryComposer feedback (salt görsel; upload logic değişmez).
  // pct: state_changed observer'ından GERÇEK yüzde (fake YOK). error/done: inline surface.
  const [storyUploadPct, setStoryUploadPct] = useState(0);
  const [storyUploadError, setStoryUploadError] = useState<string | null>(null);
  const [storyUploadDone, setStoryUploadDone] = useState(false);
  // FAZ 2A — hikaye kitlesi: "public" (herkese) | "closeFriends".
  // Toggle yalnız yakın arkadaş listesi doluysa gösterilir.
  const [storyAudience, setStoryAudience] = useState("public");
  const [hasCloseFriends, setHasCloseFriends] = useState(false);

  // Composer: dosya seçildikten sonra, yüklemeden önce düzenleme adımı
  const [composerFile, setComposerFile] = useState<File | null>(null);

  const [modalAcik, setModalAcik] = useState(false);
  // IG paritesi — modal artık TEK kullanıcı değil, sıralı grup listesi
  // üzerinde gezinir (son hikaye bitince sıradaki kullanıcıya geçer).
  const [aktifGrupIdx, setAktifGrupIdx] = useState(0);
  const [izlenenHikayeler, setIzlenenHikayeler] = useState(readWatched());

  // IG paritesi — tepsi hikaye görüntüleyici açılırken adres çubuğu modal'ın
  // replaceState'iyle /stories/{u}/{id} gösterir; kapanışta bu URL'i açılış
  // öncesine geri yazmak için önceki URL saklanır. history yığınına dokunmaz.
  const storyPrevUrlRef = useRef<string | null>(null);

  // Glow ref'leri — her story-ring için DOM ref'i tutulur
  /** Anahtar = yazar uid'i (veya kendi halkam için `"__me__"`), değer = halka
   *  `<div>`i. İki YAZAR var, ikisi de `<div ref={...}>` (750 ve 836) →
   *  `HTMLDivElement`. `| undefined` çünkü okuyucu (`applyGlow`) `if (!el)
   *  return` ile yokluğu zaten karşılıyor: henüz mount olmamış halka. */
  const ringRefs = useRef<Record<string, HTMLDivElement | undefined>>({});

  // YENİ: Cihaz tipi (mobil/masaüstü) algılama — KURAL 6 merkezi seçim
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return true;
    return window.matchMedia && window.matchMedia("(max-width: 768px)").matches;
  });
  useEffect(() => {
    const mm = window.matchMedia("(max-width: 768px)");
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    try { mm.addEventListener("change", handler); } catch { mm.addListener(handler); }
    setIsMobile(mm.matches);
    return () => {
      try { mm.removeEventListener("change", handler); } catch { mm.removeListener(handler); }
    };
  }, []);

  // watched sync (diğer tablar)
  useEffect(() => {
    const refresh = () => setIzlenenHikayeler(readWatched());
    const storageListener = (e: StorageEvent) => {
      if (e.key === "watchedStories") refresh();
    };
    window.addEventListener("mylasa-watched-updated", refresh);
    window.addEventListener("storage", storageListener);
    return () => {
      window.removeEventListener("mylasa-watched-updated", refresh);
      window.removeEventListener("storage", storageListener);
    };
  }, []);

  // ÖLÇEK FAZ 1 — İZLENDİ durumu CİHAZLAR ARASI senkron artık kullanıcının
  // KENDİ users/{me}/izlenenHikayeler alt koleksiyonundan gelir (owner-only;
  // başkalarının izlemeleri bu listener'ı tetiklemez). Legacy hikayelerde
  // izleyenler[] hâlâ doluysa o da sayılır (24h geçiş penceresi).
  // !!! Bu blok glow effect'inden ÖNCE tanımlanmalı (TDZ: isGroupSeen
  // aşağıdaki effect'in deps array'inde kullanılıyor — yanlış sırada tüm
  // uygulama "Cannot access before initialization" ile çöküyordu).
  const [seenStoryIds, setSeenStoryIds] = useState(() => new Set());
  useEffect(() => {
    const me = currentUserProfile?.uid;
    if (!me) {
      setSeenStoryIds(new Set());
      return;
    }
    return watchSeenStories(me, setSeenStoryIds);
  }, [currentUserProfile?.uid]);

  // Bir hikaye izlendi mi? (yeni subcollection kaydı VEYA legacy izleyenler[])
  /** `s` nullish olabilir — gövde `if (!s) return false` ile karşılıyor
   *  (`isGroupSeen` ve `firstUnseenIndex` `stories[]` elemanı geçiyor).
   *  `me` = `currentUserProfile?.uid` / `auth.currentUser?.uid` → opsiyonel. */
  const isStorySeen = useCallback((s: HikayeOgesi | null | undefined, me: string | undefined) => {
    if (!s) return false;
    if (seenStoryIds.has(s.id)) return true;
    return Array.isArray(s.izleyenler) && s.izleyenler.includes(me);
  }, [seenStoryIds]);

  // DENETİM FIX — halka izlenmişliği artık HİKAYE-bazlı: yazar yeni hikaye
  // atınca halka yeniden yanar. (Eski yazar-bazlı localStorage işareti hiç
  // temizlenmediğinden ertesi günkü yeni hikayeler sönük görünüyordu.)
  const isGroupSeen = useCallback((g: HikayeGrubu | null | undefined, me: string | undefined) => {
    if (!g?.stories?.length) return false;
    return g.stories.every((s) => isStorySeen(s, me));
  }, [isStorySeen]);

  // Glow'u DOM'a doğrudan yaz — render'dan bağımsız, CSS :active'den etkilenmez
  /** Tek çağrı yeri (239): `applyGlow(user.authorId, isWatched,
   *  user.hasCloseFriendsStory)` — `HikayeGrubu.authorId` opsiyonel olduğu
   *  için birinci parametre de öyle. `String(...)`: JS zaten nesne anahtarını
   *  ToPropertyKey ile string'e çeviriyor (`obj[undefined]` === `obj["undefined"]`)
   *  — yazan taraf (836) da aynı dönüşümden geçiyor, dolayısıyla çalışma
   *  zamanı DAVRANIŞI birebir aynı; yalnız örtük dönüşüm görünür kılındı. */
  const applyGlow = useCallback((authorId: string | undefined, isWatched: boolean, isCf: boolean) => {
    const el = ringRefs.current[String(authorId)];
    if (!el) return;
    const glow = isWatched ? GLOW_OFF : (isCf ? GLOW_CF : GLOW_ON);
    el.style.setProperty("box-shadow", glow, "important");
  }, []);

  // storiesByUser veya izlenmişlik değişince tüm glow'ları güncelle
  useEffect(() => {
    const me = currentUserProfile?.uid;
    storiesByUser.forEach((user) => {
      const isWatched = user.authorId === me
        ? izlenenHikayeler.includes(user.authorId)
        : isGroupSeen(user, me);
      applyGlow(user.authorId, isWatched, user.hasCloseFriendsStory);
    });
  }, [storiesByUser, izlenenHikayeler, applyGlow, isGroupSeen, currentUserProfile?.uid]);

  useEffect(() => {
    const me = currentUserProfile?.uid;
    if (!me || storiesByUser.length === 0) return;
    const local = readWatched();
    const toAdd = [];
    for (const g of storiesByUser) {
      if (g.authorId === me) continue;
      if (local.includes(g.authorId)) continue;
      const allSeen = g.stories.length > 0 &&
        g.stories.every((s) => isStorySeen(s, me));
      if (allSeen) toAdd.push(g.authorId);
    }
    if (toAdd.length > 0) {
      const next = [...local, ...toAdd];
      try {
        localStorage.setItem("watchedStories", JSON.stringify(next));
        window.dispatchEvent(new Event("mylasa-watched-updated"));
      } catch { /* no-op */ }
      setIzlenenHikayeler(next);
    }
  }, [storiesByUser, currentUserProfile?.uid, isStorySeen]);

  // FAZ 2A — yakın arkadaş listesi dolu mu? (toggle görünürlüğü; tek
  // limit(1) okuması, owner-only read).
  useEffect(() => {
    const uid = currentUserProfile?.uid;
    if (!uid) {
      setHasCloseFriends(false);
      return;
    }
    let alive = true;
    getDocs(query(collection(db, "users", uid, "closeFriends"), limit(1)))
      .then((snap) => {
        if (alive) setHasCloseFriends(!snap.empty);
      })
      .catch(() => {
        if (alive) setHasCloseFriends(false);
      });
    return () => {
      alive = false;
    };
  }, [currentUserProfile?.uid]);

  // 24 saatlik hikayeleri çek — following subcollection'dan takip listesi alınır
  useEffect(() => {
    if (!currentUserProfile) {
      setStoriesByUser([]);
      return;
    }
    const currentUserId = currentUserProfile.uid;
    let unsub: (() => void) | null = null;
    let alive = true;

    // FAZ 0 (Sosyal Grafik Güvenlik) — hikayeler LIST kuralı gizli içerik
    // koruması yapıyor; in-sorgusu public filtresi taşımak zorunda (rules
    // provability — bkz. firestore.rules posts notu). Kendi hikayelerin
    // (viewer gizli hesapsa filtreden düşer) authorId==uid sorgusuyla ayrı
    // gelir; iki snapshot birleşip gruplanır. Trade-off: gizli hesapların
    // hikayeleri halkada görünmez (Faz 3 materialized feed ile dönecek).
    /** İki üretici: `currentUserProfile.takipEdilenler` (`string[]`) ve
     *  `getFollowingUids` (`services/follows.ts:28` — `Array.from(new Set())`,
     *  yani `unknown[]`). Birleşim `unknown[]`; gövde de yalnız doğruluk
     *  kontrolü + eşitsizlik yapıyor, eleman üzerinde hiçbir string işlemi yok. */
    const startQuery = (authorIds: unknown[]) => {
      if (!alive) return;
      const followedAuthors = Array.from(new Set(authorIds))
        .filter((uid) => uid && uid !== currentUserId)
        .slice(0, 30);
      const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);

      let followedDocs: HikayeOgesi[] = [];
      let ownDocs: HikayeOgesi[] = [];
      // FAZ 2A — closeFriends hikaye inbox'ı (materialized fan-out,
      // story_close_friends.ts yazar; owner-only read).
      let inboxDocs: HikayeOgesi[] = [];
      const regroup = () => {
        const seen = new Set<string>();
        const all: HikayeOgesi[] = [];
        for (const s of [...ownDocs, ...followedDocs, ...inboxDocs]) {
          if (s && s.id && !seen.has(s.id)) {
            seen.add(s.id);
            all.push(s);
          }
        }
        // `anahtar`: JS nesne anahtarı zaten ToPropertyKey'den geçiyor
        // (`acc[undefined]` === `acc["undefined"]`) — örtük dönüşüm görünür
        // kılındı, çalışma zamanı davranışı birebir aynı.
        const grouped = all.reduce<Record<string, HikayeGrubu>>((acc, s) => {
          const anahtar = String(s.authorId);
          (acc[anahtar] ||= {
            authorId: s.authorId,
            authorUsername: s.authorUsername,
            authorProfilePic: s.authorProfilePic,
            stories: [],
            hasCloseFriendsStory: false,
            latestMs: 0,
          });
          acc[anahtar].stories.push(s);
          acc[anahtar].stories.sort(
            // tarih, local snapshot'ta (serverTimestamp pending) null olabilir
            (a, b) => (a.tarih?.toMillis?.() || 0) - (b.tarih?.toMillis?.() || 0)
          );
          if (s.audience === "closeFriends") acc[anahtar].hasCloseFriendsStory = true;
          const ms = s.tarih?.toMillis ? s.tarih.toMillis() : 0;
          if (ms > acc[anahtar].latestMs) acc[anahtar].latestMs = ms;
          return acc;
        }, {});
        setStoriesByUser(Object.values(grouped));
      };

      const unsubs: Array<() => void> = [];
      if (followedAuthors.length > 0) {
        // FAZ 2A — audience filtresi: closeFriends hikayeler bu sorgudan
        // gelmez (rules provability), inbox listener'ından gelir.
        const qFollowed = query(
          collection(db, "hikayeler"),
          where("authorId", "in", followedAuthors),
          where("authorIsPrivate", "==", false),
          where("audience", "==", "public"),
          where("tarih", ">=", twentyFourHoursAgo)
        );
        unsubs.push(
          onSnapshot(
            qFollowed,
            (snap) => {
              followedDocs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
              regroup();
            },
            (e) => console.error("Hikayeler snapshot hatası:", e)
          )
        );
      }
      const qOwn = query(
        collection(db, "hikayeler"),
        where("authorId", "==", currentUserId),
        where("tarih", ">=", twentyFourHoursAgo)
      );
      unsubs.push(
        onSnapshot(
          qOwn,
          (snap) => {
            ownDocs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
            regroup();
          },
          (e) => console.error("Hikayeler (own) snapshot hatası:", e)
        )
      );
      // FAZ 2A — yakın arkadaşı olduğum yazarların closeFriends
      // hikayeleri kendi inbox'ımdan (denorm kopya; id = storyId).
      const qInbox = query(
        collection(db, "users", currentUserId, "closeFriendStories"),
        where("tarih", ">=", twentyFourHoursAgo)
      );
      unsubs.push(
        onSnapshot(
          qInbox,
          (snap) => {
            inboxDocs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
            regroup();
          },
          (e) => console.error("Hikayeler (closeFriends inbox) snapshot hatası:", e)
        )
      );
      unsub = () => unsubs.forEach((u) => u && u());
    };

    // Önce profile'daki takipEdilenler array'ine bak, boşsa following subcollection'dan çek
    const legacyList = currentUserProfile.takipEdilenler || [];
    if (legacyList.length > 0) {
      startQuery(legacyList);
    } else {
      getFollowingUids(currentUserId)
        .then((uids) => { if (alive) startQuery(uids); })
        .catch(() => { if (alive) startQuery([]); });
    }

    return () => {
      alive = false;
      if (unsub) unsub();
    };
  }, [currentUserProfile]);

  // Dosya seçimi → COMPOSER açılır (anında yükleme yerine düzenleme adımı).
  /** Tek çağrı yeri: 789, `<input type="file" onChange={handleHikayeEkle}>`. */
  const handleHikayeEkle = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    const kullanici = auth.currentUser;
    if (!file || !kullanici || !currentUserProfile) return;

    // PR-33 — video guardrail: boyut (50MB) + süre (60sn) UPLOAD ÖNCESİ.
    // Büyük/uzun video Storage'a hiç gitmez. Süre okunamazsa net hata.
    if (file.type.startsWith("video/")) {
      const res = await validateVideoFile(file, {
        maxBytes: STORY_VIDEO_MAX_BYTES,
        maxSec: STORY_VIDEO_MAX_SEC,
        label: "Hikaye",
      });
      if (!res.ok) {
        alert(res.message);
        // ⚠️ KOD DEĞİŞİKLİĞİ (475'te de aynısı): `= null` idi. HTML standardı
        // `HTMLInputElement.value`u `[LegacyNullToEmptyString] DOMString`
        // olarak tanımlar — yani tarayıcı `null`u ZATEN `""`ye çeviriyor.
        // Yazılan değer birebir aynı; yalnız örtük legacy dönüşüm kaldırıldı.
        e.target.value = ""; // input tekrar kullanılabilir
        return;
      }
    }

    setComposerFile(file);
    e.target.value = ""; // bkz. 469'daki not (LegacyNullToEmptyString)
  };

  // Composer "Paylaş" → yükleme + doc yazımı (overlays dahil)
  /** Tek çağrı yeri: 908, `<StoryComposer onCompose={handleStoryComposed}>`.
   *  İmza ÜRETİCİDEN geliyor — `StoryComposer.tsx:118`:
   *  `onCompose?: (overlays: Overlay[], audience: string) => void`. */
  const handleStoryComposed = async (overlays: Overlay[], audience: string) => {
    const file = composerFile;
    const kullanici = auth.currentUser;
    if (!file || !kullanici || !currentUserProfile) return;
    if (audience) setStoryAudience(audience);

    // PR-ComposerV1b — yeni denemede feedback'i sıfırla (eski hata/onay kalmasın).
    setStoryUploadError(null);
    setStoryUploadDone(false);
    setStoryUploadPct(0);

    // PR-38 — GERÇEK sunucu/rules create cooldown (upload BAŞLAMADAN). Post ile
    // AYNI rateLimits/{uid} kapısı (paylaşılan content-create cooldown'ı):
    // reddedilirse Storage'a hiç dosya gitmez.
    const slot = await claimCreateSlot(kullanici.uid);
    if (!slot.ok && slot.cooldown) {
      // PR-ComposerV1b — alert() yerine composer-içi inline hata (composer açık kalır).
      setStoryUploadError("Çok sık paylaşım yapıldı. Biraz sonra tekrar dene.");
      return;
    }

    setIsUploadingStory(true);

    let fileToUpload = file;
    if (file.type.startsWith("image/")) {
      try {
        fileToUpload = await imageCompression(file, {
          maxSizeMB: 1,
          maxWidthOrHeight: 1080,
          useWebWorker: true,
        });
      } catch {
        // sıkıştırma başarısızsa orijinali yükle
      }
    }

    // PR-33 — video story için best-effort poster (siyah-ekran/spinner fix).
    // ORİJİNAL file'dan ilk-kare yakalanır, hikaye_media/'ya yüklenir; herhangi
    // bir adım hata verirse posterUrl null kalır → story akışı ASLA kırılmaz.
    let posterUrl: string | null = null;
    if (file.type.startsWith("video/")) {
      try {
        const posterBlob = await captureVideoPoster(file);
        if (posterBlob) {
          const posterPath = `hikaye_media/${kullanici.uid}/${Date.now()}_poster.jpg`;
          const posterRef = ref(storage, posterPath);
          await uploadBytesResumable(posterRef, posterBlob, { contentType: "image/jpeg" });
          posterUrl = await getDownloadURL(posterRef);
        }
      } catch { /* best-effort: poster yoksa video gri zeminle gösterilir */ }
    }

    const sanitized = (fileToUpload.name || "media").replace(
      /[^a-zA-Z0-9.]/g,
      "_"
    );
    const path = `hikaye_media/${kullanici.uid}/${Date.now()}_${sanitized}`;
    const storageRef = ref(storage, path);
    const uploadTask = uploadBytesResumable(storageRef, fileToUpload, {
      contentType: fileToUpload.type,
    });

    uploadTask.on(
      "state_changed",
      // PR-ComposerV1b — GERÇEK progress: zaten yayınlanan snapshot okunur
      // (upload path/payload/sequence DEĞİŞMEZ; yalnız no-op observer dolduruldu).
      (snap) => {
        const total = snap.totalBytes || 0;
        if (total > 0) {
          setStoryUploadPct(Math.min(100, Math.round((snap.bytesTransferred / total) * 100)));
        }
      },
      (err) => {
        console.error("Storage Yükleme Hatası:", err);
        // PR-ComposerV1b — sessiz console yerine composer-içi inline hata.
        setStoryUploadError("Yükleme başarısız oldu. Lütfen tekrar dene.");
        setIsUploadingStory(false);
      },
      async () => {
        try {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          const storagePath = uploadTask.snapshot.ref.fullPath;
          const docRef = await addDoc(collection(db, "hikayeler"), {
            authorId: kullanici.uid,
            // FAZ 0 — gizlilik damgası (kanonik güvence server trigger'da:
            // onStoryCreatePrivacyStampV3).
            authorIsPrivate: currentUserProfile.isPrivate === true,
            // FAZ 2A — kitle: closeFriends ise yalnız yakın arkadaşlar
            // (rules enforcement + story_close_friends.ts fan-out).
            audience: (audience || storyAudience) === "closeFriends" ? "closeFriends" : "public",
            authorUsername: currentUserProfile.kullaniciAdi,
            authorProfilePic: currentUserProfile.profilFoto,
            mediaUrl: url,
            // PR-33 — video story poster (best-effort; yoksa null).
            ...(posterUrl ? { posterUrl } : {}),
            mediaType: fileToUpload.type,
            contentType: fileToUpload.type,
            storagePath,
            dosyaBoyutu: fileToUpload.size || null,
            tarih: serverTimestamp(),
            createdAt: serverTimestamp(),
            // expireAt = TTL alanı (policy AÇIK — ÖLÇEK FAZ 2): arşiv artık
            // users/{uid}/storyArchive denorm kopyasından okur (medya da
            // story_archive/'a kopyalanır, onStoryCreateArchiveV3), bu yüzden
            // hikayeler doc'unun 24h sonra TTL ile silinmesi güvenli.
            // Silinince onStoryDeleteCleanupV3 subcoll + Storage'ı temizler.
            // (izlenenHikayeler ve closeFriendStories TTL'leri de AÇIK.)
            expireAt: Timestamp.fromMillis(Date.now() + 24 * 60 * 60 * 1000),
            // Legacy okuyucular için init edilir ama artık KİMSE güncellemez
            // (izlenme: hikayeler/{id}/izleyenler subcollection).
            izleyenler: [],
            viewersCount: 0,
            // IG sticker katmanı + Mylasa niş sticker'ları (StoryComposer)
            overlays: Array.isArray(overlays) ? overlays.slice(0, 10) : [],
          });

          // Fire-and-forget: 5★ content stub'ı (izleyici puanlaması için
          // ŞART — rules stub'sız rating create'i reddeder ve stub'ı
          // yalnız yazar oluşturabilir).
          ensureContentDoc(`story_${docRef.id}`, kullanici.uid, "story").catch(() => {});

          // Fire-and-forget: mention sticker'larına bildirim (gizlilik korumalı)
          if (Array.isArray(overlays) && overlays.length > 0) {
            notifyMentionsInStoryOverlays(
              docRef.id, overlays, kullanici.uid, currentUserProfile.kullaniciAdi
            );
          }

          // PR-ComposerV1b — başarı onayı: kısa yeşil ✓, sonra composer kapanır
          // (NewPost 450ms done→close deseni; tek setTimeout, loop/çift-close yok).
          setStoryUploadPct(100);
          setStoryUploadDone(true);
          setTimeout(() => {
            setComposerFile(null);
            setStoryUploadDone(false);
            setStoryUploadPct(0);
          }, 650);

          try {
            const arr = readWatched().filter((id) => id !== kullanici.uid);
            localStorage.setItem("watchedStories", JSON.stringify(arr));
            window.dispatchEvent(new Event("mylasa-watched-updated"));
          } catch {}
        } catch (err) {
          console.error("URL/Firestore hatası:", err);
          // PR-ComposerV1b — sessiz console yerine composer-içi inline hata.
          setStoryUploadError("Paylaşım tamamlanamadı. Lütfen tekrar dene.");
        } finally {
          setIsUploadingStory(false);
        }
      }
    );
  };

  // watched yaz
  /** Üç çağrı yeri (679/701/710), üçü de `aktifGrup.authorId` geçiyor →
   *  `HikayeGrubu.authorId` opsiyonel olduğu için parametre de öyle; gövde
   *  zaten `if (!authorId) return` ile karşılıyor. */
  const markAuthorWatched = (authorId: string | undefined) => {
    if (!authorId) return;
    setIzlenenHikayeler((prev) => {
      if (prev.includes(authorId)) return prev;
      const next = [...prev, authorId];
      localStorage.setItem("watchedStories", JSON.stringify(next));
      window.dispatchEvent(new Event("mylasa-watched-updated"));
      return next;
    });
  };

  // P2-6 — Sessize alınan ("all" | "stories") yazarların ring'i gizlenir;
  // kendi ring'in her zaman görünür. Post-only mute ring'i ETKİLEMEZ.
  const { storyMutedSet } = useHiddenUids({ viewerId: currentUserProfile?.uid });

  // IG TRAY SIRALAMA ALGORİTMASI (Meta'nın belgelenmiş sinyallerinin
  // client-side uyarlaması — sıfır ekstra Firestore okuması):
  //   1) Kendi hikayem her zaman ilk
  //   2) İZLENMEMİŞLER izlenmişlerden önce (büyük bonus)
  //   3) Aynı kümede: yakın arkadaş hikayesi boost'u + tazelik
  //      (24 saat yarı ömürlü üstel azalma — IG'nin recency sinyali)
  const sortedStories = useMemo(() => {
    const me = currentUserProfile?.uid;
    const now = Date.now();
    const score = (g: HikayeGrubu) => {
      if (g.authorId === me) return Infinity;
      const unseen = isGroupSeen(g, me) ? 0 : 500;
      const ageMs = g.latestMs ? now - g.latestMs : 24 * 3600 * 1000;
      const recency = Math.exp((-0.693 * ageMs) / (24 * 3600 * 1000)) * 100;
      const cfBoost = g.hasCloseFriendsStory ? 100 : 0;
      return unseen + recency + cfBoost;
    };
    return storiesByUser
      .filter((g) => g.authorId === me || !storyMutedSet.has(String(g.authorId)))
      .map((g) => ({ g, s: score(g) }))
      .sort((a, b) => b.s - a.s)
      .map((x) => x.g);
  }, [storiesByUser, isGroupSeen, currentUserProfile, storyMutedSet]);

  // Modal'ın gezineceği grup listesi — modal AÇILIRKEN dondurulur.
  // (Canlı sıralama kullanılsa, izlendi işareti düşen grup listede yer
  // değiştirir ve modal yanlış kullanıcıya atlardı.)
  // `sortedStories` (aynı grup şekli) donduruluyor — 654.
  const [viewerSession, setViewerSession] = useState<HikayeGrubu[]>([]);
  const viewerGroups = viewerSession;
  const aktifGrup = viewerGroups[aktifGrupIdx] || null;

  // IG paritesi — gruba girişte İLK İZLENMEMİŞ hikayeden devam et
  // (izlenenHikayeler senkronu + legacy izleyenler[] — bkz. isStorySeen).
  const firstUnseenIndex = useCallback((group: HikayeGrubu | null | undefined) => {
    const me = auth.currentUser?.uid;
    if (!me || !group?.stories?.length) return 0;
    const i = group.stories.findIndex((s) => !isStorySeen(s, me));
    return i === -1 ? 0 : i;
  }, [isStorySeen]);

  /** İki çağrı yeri: 726 (`handleMyStoryOpen`, `myGroup`) ve 830
   *  (tray `onClick`, `user`). İkisi de `HikayeGrubu`. */
  const handleStoryClick = (user: HikayeGrubu) => {
    // İzlendi işareti modal içinde hikaye-başına yazılır (750ms transaction);
    // burada o anki sıralama DONDURULUR ve grup index'i kurulur.
    const session = sortedStories;
    const idx = session.findIndex((g) => g.authorId === user.authorId);
    // IG paritesi — adres çubuğu modal'ın replaceState'iyle /stories/{u}/{id}
    // gösterir (paylaşılabilir + cold-load çalışır). pushState/back() YOK:
    // history yığınına dokunmuyoruz (mention/link overlay'leri navigateInApp
    // ile kendi pushState'ini yapıyor → çift-mutasyon/yarış olmasın). Kapanışta
    // önceki URL'i geri yazmak için yalnız prevUrl saklanır.
    try {
      storyPrevUrlRef.current =
        window.location.pathname + window.location.search;
    } catch (_) {
      storyPrevUrlRef.current = "/";
    }
    setViewerSession(session);
    setAktifGrupIdx(idx === -1 ? 0 : idx);
    setModalAcik(true);
  };

  // Kapanış: modalı kapat + adres çubuğunu açılış öncesi URL'e geri yaz.
  // replaceState (history girişi eklemez/çıkarmaz) → geri-tuşu davranışı
  // değişmez, overlay navigasyonuyla yarış olmaz.
  const closeStoryViewer = useCallback(() => {
    if (aktifGrup) markAuthorWatched(aktifGrup.authorId);
    setModalAcik(false);
    try {
      const prev = storyPrevUrlRef.current || "/";
      // Yalnız hâlâ bir /stories/ URL'sindeysek geri yaz — overlay navigasyonu
      // (örn. mention → /profil) URL'i zaten değiştirdiyse onu ezme.
      if (window.location.pathname.startsWith("/stories/")) {
        window.history.replaceState(window.history.state, "", prev);
      }
    } catch (_) {
      /* URL kozmetik */
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aktifGrup]);

  const handleModalClose = () => {
    closeStoryViewer();
  };

  // IG paritesi — kullanıcılar arası geçiş: son hikaye bitince veya yatay
  // kaydırmada sıradaki kullanıcıya akar; liste bitince modal kapanır.
  const handleNextUser = () => {
    if (aktifGrup) markAuthorWatched(aktifGrup.authorId);
    if (aktifGrupIdx < viewerGroups.length - 1) {
      setAktifGrupIdx(aktifGrupIdx + 1);
    } else {
      closeStoryViewer();
    }
  };

  const handlePrevUser = () => {
    if (aktifGrup) markAuthorWatched(aktifGrup.authorId);
    if (aktifGrupIdx > 0) setAktifGrupIdx(aktifGrupIdx - 1);
  };

  const myGroup = useMemo(
    () => storiesByUser.find((g) => g.authorId === currentUserProfile?.uid),
    [storiesByUser, currentUserProfile]
  );
  const hasMyStory = !!myGroup && myGroup.stories.length > 0;
  const isMyWatched =
    !!currentUserProfile?.uid &&
    izlenenHikayeler.includes(currentUserProfile.uid);

  const handleMyStoryOpen = () => {
    if (isUploadingStory) return;
    if (!hasMyStory) return;
    handleStoryClick(myGroup);
  };

  const myRingClass = `story-ring ${
    isUploadingStory
      ? "uploading"
      : hasMyStory
      ? isMyWatched
        ? "watched"
        : "unwatched"
      : "no-gradient"
  }`;

  return (
    <>
      <div className="stories-container">
        <div className="stories-scroll-area">
          {/* Benim hikayem */}
          <div className="story-item add-story">
            <div
              className={myRingClass}
              onClick={handleMyStoryOpen}
              ref={(el) => {
                if (el) {
                  ringRefs.current["__me__"] = el;
                  // Kendi hikayem için glow
                  const glow = hasMyStory && !isMyWatched ? GLOW_ON : GLOW_OFF;
                  el.style.setProperty("box-shadow", glow, "important");
                }
              }}
            >
              <div className="story-inner">
                <img
                  className="story-avatar"
                  src={
                    currentUserProfile?.profilFoto ||
                    DEFAULT_AVATAR_NEUTRAL
                  }
                  alt="Profil"
                />
              </div>

              {!isUploadingStory && (
                <>
                  <button
                    type="button"
                    className="add-story-plus-icon pressable"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={(e) => {
                      e.stopPropagation();
                      const el = document.getElementById("hikaye-upload");
                      if (el) el.click();
                    }}
                    aria-label="Hikaye ekle"
                  >
                    {/* ANLAM (§7): "+" = oluştur/ekle (hikâye) → `navigation.create`
                        (alt nav merkezi ve profil "+" ile aynı aile). `eski` aynı "+"
                        karakteri → bayrak kapalı kolda DOM birebir. Boyut xs (16 px)
                        BİR İSTİSNADIR (§2: Y=20 en küçük kademe): kutu 22 px + 2 px
                        kenarlık = 18 px iç alan; 20 px sığmaz. Kutu büyütülmez
                        (Hikayeler.css: "IG paritesinde küçük köşe damgası"). */}
                    <IkonKoprusu aile="navigation.create" boyut="xs" eski="+" />
                  </button>
                  <input
                    id="hikaye-upload"
                    type="file"
                    accept="image/*,video/*"
                    style={{ display: "none" }}
                    onClick={(e) => e.stopPropagation()}
                    onChange={handleHikayeEkle}
                    disabled={isUploadingStory}
                  />
                </>
              )}
            </div>
            <p className="story-username">Hikayen</p>
            {/* FAZ 2A — kitle seçimi (yalnız yakın arkadaş listesi doluysa).
                Yeşil: Instagram closeFriends rengi konvansiyonu. */}
            {hasCloseFriends && !isUploadingStory ? (
              <button
                type="button"
                className={
                  "story-audience-toggle pressable" +
                  (storyAudience === "closeFriends"
                    ? " story-audience-toggle--cf"
                    : "")
                }
                onClick={(e) => {
                  e.stopPropagation();
                  setStoryAudience((p) =>
                    p === "closeFriends" ? "public" : "closeFriends"
                  );
                }}
                aria-pressed={storyAudience === "closeFriends"}
                title="Yeni hikayenin kimlere görüneceğini seç"
              >
                {storyAudience === "closeFriends" ? "★ Yakın Arkadaşlar" : "Herkese"}
              </button>
            ) : null}
          </div>

          {/* Diğer kullanıcılar */}
          {sortedStories
            .filter((u) => u.authorId !== currentUserProfile?.uid)
            .map((user) => {
              const isWatched = isGroupSeen(user, currentUserProfile?.uid);
              return (
                <div
                  key={user.authorId}
                  className="story-item"
                  onClick={() => handleStoryClick(user)}
                >
                  <div
                    className={`story-ring ${isWatched ? "watched" : "unwatched"}${user.hasCloseFriendsStory ? " cf" : ""}`}
                    ref={(el) => {
                      if (el) {
                        ringRefs.current[String(user.authorId)] = el;
                        // DOM'a doğrudan yaz — CSS :active'den etkilenmez
                        el.style.setProperty(
                          "box-shadow",
                          isWatched ? GLOW_OFF : (user.hasCloseFriendsStory ? GLOW_CF : GLOW_ON),
                          "important"
                        );
                      }
                    }}
                  >
                    <div className="story-inner">
                      <img
                        className="story-avatar"
                        src={
                          user.authorProfilePic ||
                          DEFAULT_AVATAR_NEUTRAL
                        }
                        alt={user.authorUsername}
                      />
                    </div>
                  </div>
                  <p className="story-username">{user.authorUsername}</p>
                </div>
              );
            })}
        </div>
      </div>

      {/* Hikaye composer'ı — dosya seçildikten sonra düzenleme adımı */}
      {/* `fallback={null}`: eski hâlde de composer, dosya seçilene kadar DOM'da
          yoktu → boş fallback eski davranışın birebir devamıdır (araya yeni bir
          görsel katman KOYMAZ). Emsal: app/appModals.tsx aynı fallback'i kullanır. */}
      {composerFile && (
        <Suspense fallback={null}>
        <StoryComposer
          file={composerFile}
          onCompose={handleStoryComposed}
          onClose={() => {
            if (!isUploadingStory) {
              setComposerFile(null);
              // PR-ComposerV1b — kapanışta feedback'i temizle (stale hata/onay kalmasın).
              setStoryUploadError(null);
              setStoryUploadDone(false);
              setStoryUploadPct(0);
            }
          }}
          isUploading={isUploadingStory}
          uploadPct={storyUploadPct}
          uploadError={storyUploadError}
          uploadDone={storyUploadDone}
          initialAudience={storyAudience}
          hasCloseFriends={hasCloseFriends}
          authorAvatar={currentUserProfile?.profilFoto || ""}
        />
        </Suspense>
      )}

      {modalAcik && aktifGrup && (
        <Suspense fallback={null}>
        {isMobile ? (
          <StoryModalMobile
            key={aktifGrup.authorId}
            stories={aktifGrup.stories}
            initialIndex={firstUnseenIndex(aktifGrup)}
            onClose={handleModalClose}
            onNextUser={handleNextUser}
            onPrevUser={handlePrevUser}
            hasNextUser={aktifGrupIdx < viewerGroups.length - 1}
            hasPrevUser={aktifGrupIdx > 0}
          />
        ) : (
          <StoryModalDesktop
            key={aktifGrup.authorId}
            {...({
              stories: aktifGrup.stories,
              initialIndex: firstUnseenIndex(aktifGrup),
              onClose: handleModalClose,
              onNextUser: handleNextUser,
              onPrevUser: handlePrevUser,
              hasNextUser: aktifGrupIdx < viewerGroups.length - 1,
              hasPrevUser: aktifGrupIdx > 0,
            } as any)}
          />
        )}
        </Suspense>
      )}
    </>
  );
}

export default Hikayeler;
